import { render } from "./CreateContactCard.vue?vue&type=template&id=c7a71720&scoped=true"
import script from "./CreateContactCard.vue?vue&type=script&lang=js"
export * from "./CreateContactCard.vue?vue&type=script&lang=js"

import "./CreateContactCard.vue?vue&type=style&index=0&id=c7a71720&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a71720"]])

export default __exports__